module.exports = "<div class=product-description> <p>{{ product.description_summary }}</p> </div>";